import { SpinButton } from "@fluentui/react";
import React, { useEffect, useState, type SyntheticEvent } from "react";
import type { NodeProps, Node } from "@xyflow/react";
import type { ExtraNodeData, InterfaceToRecord } from "./action-config-node";
import ActionConfigNode from "./action-config-node";
import type { TimerData } from "../../../api";
import { useTranslation } from "react-i18next";
import { useUpdateNodeData } from "@/lib/hooks/reactflow";

type TimerNode = Node<InterfaceToRecord<TimerData & ExtraNodeData>>;

export default function Timer(props: NodeProps<TimerNode>): JSX.Element {
    const { t } = useTranslation();

    const [timeout, setTimeout] = useState(props.data.timeoutS ?? 1);
    const updateNode = useUpdateNodeData<TimerNode>(props.id);

    // We have to set the data to prevent undefined values
    useEffect(() => {
        updateNode({ timeoutS: timeout });
    }, [timeout, updateNode]);

    function onSpinButtonChange(
        _e: SyntheticEvent<HTMLElement, Event>,
        newValue?: string | undefined,
    ): void {
        if (!newValue) {
            return;
        }
        const newNumber = parseInt(newValue);
        setTimeout(newNumber);
    }

    return (
        <ActionConfigNode nodeKind={props.type} {...props.data}>
            <div className="spin-button-wrapper">
                <SpinButton
                    label={t("component.actionConfigNodes.timer.unit")}
                    className={"nodrag"}
                    value={timeout.toString()}
                    onChange={onSpinButtonChange}
                    min={1}
                    max={255}
                />
            </div>
        </ActionConfigNode>
    );
}
